import React, { useEffect, useState } from 'react';
import { Container, MainContent, MainContentTitle } from './styles';
import MainTitle from 'components/MainTitle';
import TouristOffersBusinessOverviewList from '../TouristOffersBusinessOverview/components/TouristOffersBusinessOverviewList';
import { useParams, Link } from 'react-router-dom';
import { IBusiness } from 'interfaces/IBusinesses';
import touristOffersBusinessService from 'services/TouristOffersBusinessService';
import { useLoading } from 'hooks/useLoading';
import editIcon from 'assets/images/editIcon.svg';
import eyeIcon from 'assets/images/eyeGrayIcon.svg';
import {
  SettingsList,
  SettingsListItem,
  SettingsListItemTitle,
  SettingsListItemButtonList,
  SettingsListItemButton,
} from 'components/List/styles';
import { SettingsListContainer, SettingsListItemButtonBox } from 'features/Config/components/Activity/styles';

const TouristOffersBusinessOverview = (): JSX.Element => {
  const { openLoading, closeLoading } = useLoading();
  const [disabled, setDisabled] = useState(false);
  const { id } = useParams<{ id?: string }>();
  const [filteredItem, setFilteredItem] = useState<IBusiness>();
  const [activities, setActivities] = useState<IBusiness[]>([]);

  useEffect(() => {
    openLoading();
    setDisabled(true);
    const fetchBusinessData = [fetchTouristOffersBusiness()];
    Promise.all(fetchBusinessData).finally(() => closeLoading());
  }, []);

  const service = {
    touristOffersBusiness: new touristOffersBusinessService(),
  };

  const fetchTouristOffersBusiness = async () => {
    const data = await service.touristOffersBusiness.findOne(Number(id?.slice(3)));
    setFilteredItem(data);

    const allActivities = await service.touristOffersBusiness.findAllTrades();
    const filtered = allActivities.filter(
      activity => activity.businessRepresentative === data.businessRepresentative && activity.id !== data.id
    );
    setActivities(filtered);
  };

  return (
    <Container>
      <MainTitle>Ofertas Turísticas / TRADE</MainTitle>
      <MainContent>
        <MainContentTitle>Detalhes do Negócio</MainContentTitle>
        <TouristOffersBusinessOverviewList disabled={disabled} item={filteredItem} />
      </MainContent>
      {filteredItem && activities.length > 0 && (
        <MainContent>
          <MainContentTitle>Atividades Cadastradas por {filteredItem.tradeName}</MainContentTitle>

          <SettingsListContainer>
            <SettingsList>
              {activities.map((activity, index) => (
                <SettingsListItem key={index}>
                  <SettingsListItemTitle>{activity.title}</SettingsListItemTitle>
                  <SettingsListItemButtonList>
                    <SettingsListItemButtonBox>
                      <Link to={`/admin/activity/${activity.id}/preview`}>
                        <SettingsListItemButton>
                          <img src={eyeIcon} alt="visualizar" />
                        </SettingsListItemButton>
                      </Link>
                    </SettingsListItemButtonBox>
                  </SettingsListItemButtonList>
                </SettingsListItem>
              ))}
            </SettingsList>
          </SettingsListContainer>
        </MainContent>
      )}
    </Container>
  );
};

export default TouristOffersBusinessOverview;
